var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicine11SvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "64px",
    width: "64px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#ffffff;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M471.78,276.233l0.114,0.107l-237.5-234.786l0.008,0.016c-26.765-26.78-62.007-40.235-97.092-40.213 C102.222,1.335,66.988,14.789,40.216,41.57C13.431,68.341-0.024,103.584,0,138.673c-0.024,35.081,13.431,70.323,40.216,97.095 l237.439,234.732l-0.065-0.069c26.772,26.78,62.006,40.235,97.103,40.212c35.081,0.023,70.316-13.432,97.088-40.204 c26.788-26.78,40.242-62.022,40.22-97.111C512.023,338.239,498.568,302.997,471.78,276.233z M164.543,311.881 c-0.069,0.214-0.119,0.413-0.191,0.628L63.327,212.633l0.008,0.016c-20.454-20.47-30.62-47.15-30.636-73.976 c0.015-26.834,10.181-53.507,30.636-73.976c20.47-20.454,47.146-30.624,73.976-30.639c26.826,0.015,53.503,10.185,73.972,30.639 l0.108,0.108l104.753,103.55c-20.662,4.335-39.32,11.962-55.704,21.78c-35.46,21.274-60.67,52.043-77.273,80.876 C174.862,285.453,168.708,299.459,164.543,311.881z M448.66,447.311c-20.469,20.447-47.142,30.617-73.968,30.632 c-26.838-0.015-53.514-10.177-73.984-30.639l-0.061-0.061L191.238,339.081c0.326-2.105,0.808-4.58,1.508-7.321 c2.531-10.132,7.628-23.786,15.316-38.221c11.525-21.695,28.886-45.204,51.829-63.339c22.84-18.02,50.857-30.892,85.582-32.845 l103.142,101.958l0.045,0.038c20.462,20.47,30.624,47.15,30.64,73.976C479.285,400.153,469.123,426.834,448.66,447.311z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.477,170.66l35.747-85.456c-13.417,0-26.026,5.216-35.503,14.696 C62.148,119.473,62.148,151.331,81.477,170.66z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine11SvgrepoCom);
export default __webpack_public_path__ + "static/media/medicine-11-svgrepo-com.7c09fde5def590f62fbf98dd80edc945.svg";
export { ForwardRef as ReactComponent };